import { extendTheme } from '@chakra-ui/react';
import Button from './components/button';
import Heading from './components/heading';
import colors from './foundations/colors';
import styles from './styles';

export default extendTheme({
  radii: { '4xl': `1.813rem`, '5xl': `2.313rem`, '6xl': `4rem` },
  styles,
  colors,
  fontSizes: {
    '2-5xl': `1.688rem`,
    '3-5xl': `2rem`,
    '4-5xl': `2.5rem`,
  },
  components: { Heading, Button },
});
